import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './call/HttpClientCall.mjs';
import {
  toString1pkumu07cwy4m as toString,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { defaultTransformers2r9wd7ftt31zw as defaultTransformers } from './plugins/DefaultTransform.mjs';
import {
  get_HttpResponseReceiveFailed2q0s5em07bm9j as get_HttpResponseReceiveFailed,
  HttpResponseReceiveFailk4vfmxmwithf as HttpResponseReceiveFail,
  get_HttpRequestCreated2xa7wfn254wyu as get_HttpRequestCreated,
} from './utils/ClientEvents.mjs';
import { HttpClientConfigo6p492ed655g as HttpClientConfig } from './HttpClientConfig.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { atomic$boolean$1iggki4z65a2h as atomic$boolean$1 } from '../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import {
  Key_instancebefxze3q9f64 as Key_instance,
  Job13y4jkazwjho0 as Job,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import {
  HttpRequestPipeline1v7xct5dgezuy as HttpRequestPipeline,
  HttpSendPipeline3tm1hram7cjxt as HttpSendPipeline,
  Phases_getInstance2m4et9xkapx2y as Phases_getInstance,
} from './request/HttpRequestPipeline.mjs';
import {
  HttpResponsePipeline14ucx7kbf4hm2 as HttpResponsePipeline,
  HttpReceivePipeline1ousblrss634z as HttpReceivePipeline,
  Phases_getInstance2qxbzj50paf3c as Phases_getInstance_0,
} from './statement/HttpResponsePipeline.mjs';
import { AttributesJsFn25rjfgcprgprf as AttributesJsFn } from '../../../../ktor-ktor-utils/io/ktor/util/Attributes.web.mjs';
import { Events63tfxre48w4z as Events } from '../../../../ktor-ktor-events/io/ktor/events/Events.mjs';
import { get_HttpRequestLifecycle1e7j0z243lnj5 as get_HttpRequestLifecycle } from './plugins/HttpRequestLifecycle.mjs';
import { get_BodyProgresstom4nhodv8bj as get_BodyProgress } from './plugins/BodyProgress.mjs';
import { get_SaveBody3aignvhtsnvcr as get_SaveBody } from './plugins/SaveBody.mjs';
import { Plugin_getInstance305tjh8i5k0u9 as Plugin_getInstance } from './plugins/HttpSend.mjs';
import { get_HttpCallValidator3iji36qylbtbr as get_HttpCallValidator } from './plugins/HttpCallValidator.mjs';
import { get_HttpRedirect1lgx3wewnhrb0 as get_HttpRedirect } from './plugins/HttpRedirect.mjs';
import { get_HttpPlainText2hd9sygnz4kij as get_HttpPlainText } from './plugins/HttpPlainText.mjs';
import { addDefaultResponseValidation1d06vtgr9flaj as addDefaultResponseValidation } from './plugins/DefaultResponseValidation.mjs';
import { HttpClientEngineBase2tgisnw4e4drr as HttpClientEngineBase } from './engine/HttpClientEngineBase.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { cancel36mj9lv3a0whl as cancel } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { get_PLUGIN_INSTALLED_LIST1ftwjhwye1pz5 as get_PLUGIN_INSTALLED_LIST } from './plugins/HttpClientPlugin.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import { AutoCloseable1l5p57f9lp7kv as AutoCloseable } from '../../../../kotlin-kotlin-stdlib/kotlin/AutoCloseableJs.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function HttpClient$slambda(this$0) {
  return constructCallableReference(function *($this$intercept, call, $completion) {
    // Inline function 'kotlin.check' call
    if (!(call instanceof HttpClientCall())) {
      var message = 'Error: HttpClientCall expected, but found ' + toString(call) + '(' + toString(getKClassFromExpression(call)) + ').';
      throw IllegalStateException().o(toString(message));
    }
    var response = yield* this$0.g5g_1.u4s(Unit_instance, call.q5g(), $completion);
    call.r5g(response);
    yield* $this$intercept.x4r(call, $completion);
    return Unit_instance;
  }, 2);
}
function HttpClient$lambda($this$install) {
  defaultTransformers($this$install);
  return Unit_instance;
}
function HttpClient$slambda_0(this$0) {
  return constructCallableReference(function *($this$intercept, it, $completion) {
    try {
      yield* $this$intercept.y4r($completion);
    } catch ($p) {
      if ($p instanceof Error) {
        var cause = $p;
        this$0.j5g_1.b4u(get_HttpResponseReceiveFailed(), new (HttpResponseReceiveFail())($this$intercept.v4s_1.q5g(), cause));
        throw cause;
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }, 2);
}
var HttpClientClass;
function HttpClient() {
  if (HttpClientClass === VOID) {
    class $ {
      constructor(engine, userConfig) {
        return new.target.s5g(engine, userConfig);
      }
      static s5g(engine, userConfig) {
        userConfig = userConfig === VOID ? new (HttpClientConfig())() : userConfig;
        var $this = createThis(this);
        $this.x5f_1 = engine;
        $this.y5f_1 = userConfig;
        $this.z5f_1 = false;
        $this.a5g_1 = atomic$boolean$1(false);
        $this.b5g_1 = Job($this.x5f_1.bw().bd(Key_instance));
        $this.c5g_1 = $this.x5f_1.bw().pm($this.b5g_1);
        $this.d5g_1 = new (HttpRequestPipeline())();
        $this.e5g_1 = new (HttpResponsePipeline())();
        $this.f5g_1 = new (HttpSendPipeline())();
        $this.g5g_1 = new (HttpReceivePipeline())();
        $this.h5g_1 = AttributesJsFn(true);
        $this.i5g_1 = $this.x5f_1.t5g();
        $this.j5g_1 = new (Events())();
        $this.k5g_1 = new (HttpClientConfig())();
        $this.x5f_1.u5g($this);
        var tmp = Phases_getInstance().z5g_1;
        $this.f5g_1.z4s(tmp, HttpClient$slambda($this));
        // Inline function 'kotlin.with' call
        var $this$with = $this.y5f_1;
        $this.k5g_1.i5h(get_HttpRequestLifecycle());
        $this.k5g_1.i5h(get_BodyProgress());
        $this.k5g_1.i5h(get_SaveBody());
        if ($this$with.f5h_1) {
          $this.k5g_1.j5h('DefaultTransformers', HttpClient$lambda);
        }
        $this.k5g_1.i5h(Plugin_getInstance());
        $this.k5g_1.i5h(get_HttpCallValidator());
        if ($this$with.e5h_1) {
          $this.k5g_1.i5h(get_HttpRedirect());
        }
        $this.k5g_1.k5h($this$with);
        if ($this$with.f5h_1) {
          $this.k5g_1.i5h(get_HttpPlainText());
        }
        addDefaultResponseValidation($this.k5g_1);
        $this.k5g_1.u5g($this);
        var tmp_0 = Phases_getInstance_0().l5h_1;
        $this.e5g_1.z4s(tmp_0, HttpClient$slambda_0($this));
        return $this;
      }
      static q5h(engine, userConfig, manageEngine) {
        var $this = this.s5g(engine, userConfig);
        $this.z5f_1 = manageEngine;
        if ($this.z5f_1) {
          if (engine instanceof HttpClientEngineBase()) {
            engine.t5h_1.atomicfu$incrementAndGet();
          }
          var tmp = ensureNotNull($this.c5g_1.bd(Key_instance));
          tmp.ex((cause) => {
            var tmp;
            if (!(engine instanceof HttpClientEngineBase())) {
              tmp = true;
            } else {
              tmp = engine.t5h_1.atomicfu$decrementAndGet() <= 0;
            }
            var shouldClose = tmp;
            var tmp_0;
            if (shouldClose) {
              var tmp_1;
              if (cause == null) {
                engine.l6();
                tmp_1 = Unit_instance;
              } else {
                var tmp0_elvis_lhs = cause instanceof CancellationException() ? cause : null;
                cancel(engine, tmp0_elvis_lhs == null ? CancellationException().p('Client scope is canceled', cause) : tmp0_elvis_lhs);
                tmp_1 = Unit_instance;
              }
              tmp_0 = tmp_1;
            }
            return Unit_instance;
          });
        }
        return $this;
      }
      bw() {
        return this.c5g_1;
      }
      *w5h(builder, $completion) {
        this.j5g_1.b4u(get_HttpRequestCreated(), builder);
        var tmp = yield* this.d5g_1.u4s(builder, builder.a5i_1, $completion);
        return tmp instanceof HttpClientCall() ? tmp : THROW_CCE();
      }
      l6() {
        var success = this.a5g_1.atomicfu$compareAndSet(false, true);
        if (!success)
          return Unit_instance;
        var installedFeatures = this.h5g_1.h4n(get_PLUGIN_INSTALLED_LIST());
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = installedFeatures.o4n().p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          var plugin = installedFeatures.h4n(element instanceof AttributeKey() ? element : THROW_CCE());
          if (isInterface(plugin, AutoCloseable())) {
            plugin.l6();
          }
        }
        this.b5g_1.t12();
      }
      toString() {
        return 'HttpClient[' + toString(this.x5f_1) + ']';
      }
    }
    initMetadataForClass($, 'HttpClient', VOID, VOID, [AutoCloseable()], [1]);
    HttpClientClass = $;
  }
  return HttpClientClass;
}
function HttpClient_0(engine, block) {
  // Inline function 'kotlin.apply' call
  var this_0 = new (HttpClientConfig())();
  block(this_0);
  return HttpClient().q5h(engine, this_0, false);
}
function HttpClient_1(engineFactory, block) {
  var tmp;
  if (block === VOID) {
    tmp = HttpClient$lambda_0;
  } else {
    tmp = block;
  }
  block = tmp;
  // Inline function 'kotlin.apply' call
  var this_0 = new (HttpClientConfig())();
  block(this_0);
  var config = this_0;
  var engine = engineFactory.d5i(config.d5h_1);
  return HttpClient().q5h(engine, config, true);
}
function HttpClient$lambda_0(_this__u8e3s4) {
  return Unit_instance;
}
//region block: exports
export {
  HttpClient_0 as HttpClienthpouyso1j6ge,
  HttpClient_1 as HttpClient2x7qc5z8fmeal,
};
//endregion

//# sourceMappingURL=HttpClient.mjs.map
